interface AppConfig {
    apiUrl: string;
}

const appConfig: AppConfig = {
    apiUrl: (process.env["REACT_APP_API_URL"] as string).replace(/[/]+$/, ""),
};

export default appConfig;
